import { generateSetChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'

export default {
  namespaced: true,
  state: {
    serverData: {}
  },
  actions: {
    async getCart ({ commit }) {
      try {
        const result = await service.cart()
        commit('setServerData', { item: result })
      } catch (err) {
        // this would be an server error but we dont know any
        console.error('Service:getCart servererror', err)
      }
    }
  },
  getters: {
    hasCart (state) {
      return state.serverData
        ? state.serverData.store_id !== 0
        : false
    },
    cartPriceDisplay (state) {
      if (state.serverData) {
        return state.serverData.amount > 0
          ? state.serverData.price.toFixed(2)
          : '0.00'
      }
      return ''
    },
    cartAmount (state) {
      return state.serverData
        ? state.serverData.amount
        : ''
    },
    cartStoreName (state) {
      return state.serverData
        ? state.serverData.store_name
        : ''
    },
    cartStoreId (state) {
      return state.serverData
        ? state.serverData.store_id
        : ''
    },
    cartDeliveryType (state) {
      return state.serverData && state.serverData.store_id !== 0
        ? state.serverData.type
        : 'delivery'
    },
    cartShopLink (state, getters) {
      if (state.serverData) {
        return config.WEBSHOP_ENDPOINT + '/listArticle'
        // if (getters.cartDeliveryType === 'takeaway') {
        //   return config.WEBSHOP_ENDPOINT + config.WEBSHOP_ENDPOINT_TAKEAWAY.replace('%s', state.serverData.store_id)
        // } else {
        //   return config.WEBSHOP_ENDPOINT + config.WEBSHOP_ENDPOINT_TAKEAWAY.replace('%s', state.serverData.store_id).replace('%s', state.serverData.deliveryarea_id)
        // }
      } else {
        return 0
      }
    }

  },
  mutations: {
    setServerData: generateSetChild('serverData')
  }
}
